import { indexForKey } from './carouselIndex.ts';

// Keys an inner control already used (tab list, carousel) arrive default-prevented and are skipped.
export function fullscreenKeyIndex(
    key: string,
    alreadyHandled: boolean,
    current: number,
    count: number
): number | null {
    if (alreadyHandled) return null;
    return indexForKey(key, current, count);
}
